import { useEffect, useState } from 'react';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { useQueryClient } from '@/domains/core/httpClient/queryClient';

import { useWishlistServices } from '../../Wishlists/hooks/useWishlistServices';
import type {
  WishlistDetail,
  WishlistDetailsContent,
  WishlistUnit,
} from '../../Wishlists/interfaces';
import { ABTests } from '../abTests';
import { ID_WISHLIST_ALL_PRODUCTS } from '../constants';

export const useGetWishlistsData = (data: WishlistUnit[] | undefined) => {
  const queryClient = useQueryClient();
  const { calls, names } = useWishlistServices();
  const [imagesLoading, setImagesLoading] = useState(false);
  const [dataWishlists, setWishLists] = useState<WishlistDetail[]>([]);
  const [isWishlistRevampEnabled] = useBooleanFlags([
    ABTests.WISHLIST_REVAMP_ENABLED,
  ]);

  useEffect(() => {
    const wishListData = isWishlistRevampEnabled
      ? data?.filter((listItem) => listItem.id !== ID_WISHLIST_ALL_PRODUCTS)
      : data;
    const asynFn = async () => {
      const wishlists = await Promise.all(
        (wishListData || []).map(async ({ id, name, productCount }) => {
          try {
            const oneWishlistData: WishlistDetailsContent =
              await queryClient.fetchQuery({
                queryKey: [names.getOne, id],
                queryFn: () => calls.getOne,
              });

            const products = oneWishlistData?.products || [];
            return {
              id,
              name,
              productCount,
              imageUrl: products.length
                ? products[products.length - 1]?.image
                : undefined,
            };
          } catch (error) {
            return {
              id,
              name,
              productCount,
              imageUrl: undefined,
            };
          }
        }),
      );
      setWishLists(wishlists);
      setImagesLoading(false);
    };

    if (wishListData?.length) {
      setImagesLoading(true);
      asynFn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return { imagesLoading, dataWishlists };
};
